'use strict';

$(document).ready(function () {

    // mobile menu

    $(".js-mobileNavigation").on('click', function (e) {
        e.preventDefault();
        $(".navigation").fadeToggle(200);
        $(this).toggleClass('is-active');
    });

    // slider

    $('.js-slider').slick({
        arrow: true,
        appendArrows: $('.js-arrow'),
        prevArrow: '<a href="#" class="section-hp__link section-hp__link--effect1"><</a>',
        nextArrow: '<a href="#" class="section-hp__link section-hp__link--effect2">></a>'
    });

    $(".unhide1").on( "click", function( event ) {
        event.preventDefault();
        $(".initially-hidden1").toggle("slide");
    });
});

// BEFORE BANNER
$(document).ready(function () {
    $(".follow").click(function () {
        slideAway();
        return false;
    });
    $("#overlay").click(function () {
        slideAway();
        return false;
    });
});

function slideAway() {
    $('#overlay').fadeOut(800);
    $('#slideBanner').animate({
        top: -600
    }, 800, function () {
        $('#slideBanner').hide();
    });
}
